import {
  Model, attr, fk
} from 'redux-orm'
import {
  ADD_SUBTASKS, MY_SUBTASKS_SUCCEEDED,
  SUBTASK_DETAILS_UPDATE_REQUESTED,
  UPDATE_SUBTASK_DETAILS, SUBTASK_DETAILS_UPDATE_SUCCEEDED,
  DELETE_SUBTASK, DELETE_SUBTASKS, CREATE_SUBTASK,
  SUBTASK_UPDATE, UPDATE_SUBTASKS, CLONE_SUBTASKS_UPDATE
} from '../../actionTypes'

export default class extends Model {
  static modelName = 'Subtask';

  static fields = {
    id: attr(),
    position: attr(),
    name: attr(),
    description: attr(),
    lane_id: fk({
      to: 'Lane',
      as: 'lane',
      relatedName: 'subtasks'
    }),
    isLoading: attr({
      getDefault: () => false
    }),
    statsLoading: attr({
      getDefault: () => false
    })
  };

  static reducer ({
    type, payload
  }, Subtask) {
    switch (type) {
    // case SUBTASK_UPDATE:
    //   Subtask.withId(payload.id).update(payload.data)

    //   break
    // case SUBTASK_DETAILS_UPDATE_REQUESTED:
    // {
    //   const savedData = {
    //     isLoading: true
    //   }
    //   Subtask.withId(payload.id).update(savedData)
    //   break
    // }

    // case SUBTASK_DETAILS_UPDATE_SUCCEEDED:
    //   Subtask.withId(payload.id).update(payload.data)
    //   break

    // case UPDATE_SUBTASKS:
    //   payload.cards.forEach((card) => {
    //     if (Subtask.withId(card.id)) {
    //       Subtask.withId(card.id).update(card)
    //     } else {
    //       Subtask.upsert(card)
    //     }
    //   })
    //   break

    // case PARENT_CARD_DETAILS_UPDATE_SUCCEEDED:
    //   Subtask.withId(payload.id).update(payload.data)
    //   break

    // case CLONE_SUBTASKS_UPDATE:
    //   payload.cards.forEach((card) => {
    //     Subtask.upsert(card)
    //   })

    //   break

    // case DELETE_SUBTASK:
    //   Subtask.withId(payload.id).delete()
    //   break

    // case DELETE_SUBTASKS:
    //   payload.cards.forEach((cardId) => {
    //     Subtask.withId(cardId).delete()
    //   })
    //   break

    // case CREATE_SUBTASK:
    //   Subtask.upsert(payload.data)
    //   break

    // case CLEAR_STATE:
    //   payload.data.cards.forEach((card) => {
    //     Subtask.withId(card.id).delete()
    //   })
    //   break
    case MY_SUBTASKS_SUCCEEDED:

      payload.cards.forEach((card) => {
        Subtask.upsert(card)
      })

      break
    case ADD_SUBTASKS:
      payload.cards.forEach((card) => {
        Subtask.upsert(card)
      })

      break
    case SUBTASK_DETAILS_UPDATE_REQUESTED:
    {
      const savedData = {
        isLoading: true
      }
      Subtask.withId(payload.id).update(savedData)
      break
    }
    case UPDATE_SUBTASK_DETAILS:
      Subtask.withId(payload.id).update(payload.data)
      break
    case SUBTASK_DETAILS_UPDATE_SUCCEEDED:
      Subtask.withId(payload.id).update(payload.data)
      break
    case DELETE_SUBTASK:
      const subtaskToDelete = Subtask.withId(payload.id)
      if (subtaskToDelete) {
        subtaskToDelete.delete()
      }
      break

    case DELETE_SUBTASKS:
      payload.cards.forEach((card) => {
        const subtask = Subtask.withId(card.id)
        if (subtask) {
          subtask.delete()
        }
      })
      break
    case CLONE_SUBTASKS_UPDATE:
      payload.cards.forEach((card) => {
        Subtask.upsert(card)
      })

      break
    case CREATE_SUBTASK:
      Subtask.upsert(payload.data)
      break
    case SUBTASK_UPDATE:
      Subtask.withId(payload.id).update(payload.data)

      break
    case UPDATE_SUBTASKS:
      payload.cards.forEach((card) => {
        if (Subtask.withId(card.id)) {
          Subtask.withId(card.id).update(card)
        } else {
          Subtask.upsert(card)
        }
      })
      break
    default:
    }
  }
}
